import axios from 'axios'
import React, { useEffect } from 'react'
import { Notification } from '../notifications'
import { useUser } from '../../helpers/useUser'
import { getUser } from '../auth/LoginState'

type FPE = {
    modal: (param: boolean) => void
    post: any
    getPosts: () => void
}

const PostEscalate: React.FC<FPE> = ({ modal, post, getPosts }) => {

    const USER = getUser()

    const escalate = async () => {

        try {
            const res = await axios({
                method: 'put',
                url: `${process.env.REACT_APP_SERVER}/api/admin/post/moderation/escalate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Token ${USER.token}`,
                },
                data: {
                    postId: post._id,
                },
            })
            if (res.status === 201) {
                modal(false)

                return Notification({
                    message: 'Post successfully escalated.',
                    type: 'success',
                })
            } else {
                return Notification({
                    message:
                        'There was a problem with your request. Please try again later. If the problem continues, please contact developers.',
                    type: 'warning',
                })
            }
        } catch (error: any) {
            return Notification({
                message: error.message ? error.message : error,
                type: 'danger',
            })
        }
    }

    useEffect(() => {
        window.addEventListener('click', (e: any) => {
            if (e.target.id == 'modal-container') {
                modal(false)
            }
        })
    }, [])

    return (
        <div className='fixed top-0 left-0 z-50 w-full h-full bg-black/80 backdrop-blur-md'
        id='modal-container'>
            <div className='flex items-center justify-end h-11'
            id='modal-container'>
                <button
                    className='flex w-10 h-10 rounded-full bg-purple1 items-center justify-center text-xl font-cgbold mr-4'
                    onClick={() => modal(false)}
                >
                    X
                </button>
            </div>

            <div className='w-full max-h-min mx-auto md:px-6 absolute h-[calc(100%_-_2.75rem)] overflow-y-auto overscroll-contain py-2'
            id='modal-container'>
                <div className='p-2 md:p-0 flex justify-center'
                id='modal-container'>
                    <div className='bg-white max-w-4xl mx-auto rounded-xl p-2'>
                        {post ? (
                            <>
                                <h2 className='text-5xl text-center font-cgbold mt-2'>Escalate Post</h2>
                                <h5 className='mt-4 font-cgbold text-center text-xl'>
                                    Are you sure that you want to Escalate this Post?
                                </h5>

                                <div className='my-4'>
                                    <div className='flex justify-between'>
                                        <button
                                            type='submit'
                                            className='bg-red1 font-cgbold rounded-full py-2 px-6'
                                            onClick={() => {
                                                escalate()
                                            }}
                                        >
                                            Escalate Post
                                        </button>
                                        <button
                                            type='button'
                                            className='bg-purple1 font-cgbold rounded-full py-2 px-6'
                                            onClick={() => {
                                                modal(false)
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PostEscalate
